module.exports = __webpack_public_path__ + "static/img/BR.2c2f4df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/BR.svg
// module id = KUQS
// module chunks = 66